import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorPage from "../../shared/ErrorPage";
import Loading from "../../shared/Loading";
import axiosInstance from "../../utilities/axiosInstance/axiosInstance";
import ProductCard2 from "../ProductCard/ProductCard2";
import ProductCard3 from "../ProductCard/ProductCard3";
import Swal from "sweetalert2";

const ProductDetails1 = ({ handleChanges, changes }) => {
  const navigate = useNavigate();
  // const product = JSON.parse(localStorage.getItem("purchase"));
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [isDiscounted, setIsDiscounted] = useState(false);
  useEffect(() => {
    setUserInfo(JSON.parse(localStorage.getItem("user")));
  }, []);
  const [_id, setId] = useState("");

  const location = useLocation();
  useEffect(() => {
    setId(location?.search?.split("=")[1]);
  }, [location]);

  const [imgDis, setImgDis] = useState("");
  const handleDisImg = (img) => {
    setImgDis(img);
  };

  const {
    isLoading1,
    isError1,
    data: product,
    error1,
  } = useQuery(["productdetails", _id], async () => {
    // console.log(_id);
    let fdata = await axiosInstance.get(
      `product/find?_id=${location.search.split("=")[1]}`
    );
    setImgDis(fdata?.data?.img);
    let returndata = fdata?.data;
    let gImg = returndata.gallary_img;
    gImg = [returndata.img, ...gImg];
    returndata.gallary_img = gImg;
    return returndata;
  });

  const {
    isLoading2,
    isError2,
    data: discount,
    error2,
  } = useQuery(["discountdatapd"], async () => {
    let fdata = await axiosInstance.get("discount/get-active?limit=1");
    // console.log(fdata.data[0]);
    return fdata.data[0];
  });
  useEffect(() => {
    if (product?.categories?.includes(discount?.category))
      setIsDiscounted(true);
  }, [discount, product]);

  //purchase /add to cart btn
  const handleAddToCart = async () => {
    if (!userInfo) return navigate("/login");
    let fdata = await axiosInstance.get(`cart/find?userId=${userInfo?._id}`);

    if (fdata.data === null) {
      let updateddoc = await axiosInstance.post("cart/create", {
        userId: `${userInfo?._id}`,
        products: [
          {
            productId: `${product?._id}`,
            quantity: 1,
          },
        ],
      });

      if (updateddoc.status === 201)
        Swal.fire({
          icon: "success",
          title: "Successfully Added to cart",
          showCancelButton: true,
          confirmButtonText: "Take me to Cart",
          confirmButtonColor: "green",
        }).then((result) => {
          handleChanges(changes + 1);
          if (result.isConfirmed) {
            navigate("/my-cart");
          }
        });

      // console.log(updateddoc.data);
    } else {
      let productArray = fdata?.data?.products;
      let obj = {
        productId: `${product?._id}`,
        quantity: 1,
      };

      let flag = false;
      productArray.map((x) => {
        if (x.productId === product?._id) flag = true;
      });

      if (flag) {
        // console.log("alradey includes");
        Swal.fire("Alas!", "Your product alradey in the cart!", "warning");
      } else {
        productArray.push(obj);
        // console.log(productArray);
        let updateddata = await axiosInstance.put(
          `cart/update?userId=${userInfo?._id}&&_id=${fdata?.data?._id}`,
          productArray
        );

        if (updateddata.status === 200)
          Swal.fire({
            icon: "success",
            title: "Successfully Added to cart",
            showCancelButton: true,
            confirmButtonText: "Take me to Cart",
            confirmButtonColor: "green",
          }).then((result) => {
            handleChanges(changes + 1);
            if (result.isConfirmed) {
              navigate("/my-cart");
            }
          });

        // console.log(updateddata.data);
      }
    }
  };

  const {
    isLoading,
    isError,
    data: products,
    error,
  } = useQuery(["productpd1"], async () => {
    let fdata = await axiosInstance.get("product/get?limit=4");
    return fdata.data;
  });

  if (isError || isError1) return <ErrorPage msg={error || error1}></ErrorPage>;

  if (isLoading || isLoading1) return <Loading msg="Loading..."></Loading>;
  if (loading) return Swal.showLoading();

  return (
    <div className="w-full lg:px-20 sm:px-4 my-20">
      {/* starting part */}
      <div className="flex lg:flex-row md:flex-row sm:flex-col justify-start gap-10">
        {/* image part */}
        <div className="lg:w-5/12 md:w-5/12 sm:w-full flex flex-col gap-6 justify-centers items-center">
          <img className="w-auto  border border-gray-300" src={imgDis} alt="" />
          <div className="grid grid-cols-4 gap-2 ">
            {product?.gallary_img?.map((x, index) => {
              return (
                <button onClick={() => handleDisImg(x)} key={index}>
                  <img className="border border-gray-300" src={x} alt="" />
                </button>
              );
            })}
          </div>
        </div>
        {/* des part */}
        <div className="lg:w-7/12 md:w-7/12 sm:w-full">
          <p className="text-2xl font-bold">{product?.title}</p>
          {/* rating */}
          <div className="flex justify-start items-center my-1">
            <div className="rating rating-xs ">
              <input
                type="radio"
                name="rating-5"
                className="mask mask-star-2 bg-orange-400"
              />
              <input
                type="radio"
                name="rating-5"
                className="mask mask-star-2 bg-orange-400"
              />
              <input
                type="radio"
                name="rating-5"
                className="mask mask-star-2 bg-orange-400"
              />
              <input
                type="radio"
                name="rating-5"
                className="mask mask-star-2 bg-orange-400"
              />
              <input
                type="radio"
                name="rating-5"
                className="mask mask-star-2 bg-orange-400"
              />
            </div>
            <p className="text-sm ml-4">No Reviews</p>
          </div>
          <div className="flex lg:flex-row md:flex-row sm:flex-col items-center font-bold">
            {isDiscounted ? (
              <p className=" text-red-500 text-3xl">
                BDT
                {isDiscounted
                  ? (product?.unit_price * discount?.value) / 100
                  : product?.unit_price}
              </p>
            ) : (
              <></>
            )}
            <p className={isDiscounted ? "line-through ml-2" : ""}>
              ${product?.unit_price}
            </p>
          </div>

          <p className="my-4 text-sm ">
            SKU:
            <br /> {product?.description}
          </p>
          <div className="flex justify-start items-center gap-5 mt-14">
            <button
              onClick={handleAddToCart}
              className="btn btn-sm btn-warning rounded-none text-white"
            >
              Purchase
            </button>
            <button className="btn btn-sm btn-warning rounded-none text-white">
              Add To Wishlish
            </button>
          </div>
        </div>
      </div>

      {/* eending part */}
      <div className="mt-10  ">
        <table className="border-collapse border border-slate-500 w-full text-sm ">
          <thead>
            <tr>
              <th className="border border-gray-200 p-2 w-4/12">
                Specification
              </th>
              <th className="border border-gray-200 p-2 w-8/12">Details</th>
            </tr>
          </thead>
          <tbody>
            {product?.specification.map((x, index) => {
              return (
                <tr key={index}>
                  <td className="border border-gray-200 p-4">{x?.key}</td>
                  <td className="border border-gray-200 p-4">{x?.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* related products */}
      <div className="mt-16">
        <div className="border border-gray-200 my-6 p-3 flex justify-between items-center">
          <p className="font-bold">Related Products</p>
          <div className="grid grid-cols-2 gap-1">
            <button className="btn btn-sm border border-gray-100 bg-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="gray"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5L8.25 12l7.5-7.5"
                />
              </svg>
            </button>
            <button className="btn btn-sm  border border-gray-100 bg-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="gray"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-3">
          {products.map((x, index) => {
            return <ProductCard2 key={index} props={x}></ProductCard2>;
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductDetails1;
